import WarningColored from '@/images/WarningColored.svg';
import {
    Buttons,
    DeleteCloseButton,
    DeleteDialog,
    DeleteText,
    StyledButton,
    Text,
    TitleWithImg,
} from '@/pages/avatar/components/Styled/Modal';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    open: boolean;
    onClose: () => void;
    onCancel: () => void;
    onSave: () => void;
}

export const DisableConfirmationModal = ({ open, onClose, onCancel, onSave }: Props) => {
    return (
        <DeleteDialog open={open}>
            <div>
                <TitleWithImg>
                    <img src={WarningColored} />
                    <Text>Disable Insights?</Text>
                </TitleWithImg>
                <DeleteCloseButton ariaLabel="close" onClick={onClose}>
                    <CloseIcon />
                </DeleteCloseButton>
            </div>
            <DeleteText>
                This will delete your existing insights data and stop them from populating. To get insights, you’ll need to{' '}
                <b>toggle them back on</b>.
            </DeleteText>
            <Buttons>
                <StyledButton onClick={onCancel} variant="outlined" color="secondary">
                    Cancel
                </StyledButton>
                <StyledButton onClick={onSave} variant="contained" color="error">
                    Disable
                </StyledButton>
            </Buttons>
        </DeleteDialog>
    );
};
